import { forwardRef } from "react";
import { Link as RouterLink, NavLink as RouterNavLink, useLocation } from "react-router-dom";
import { parseLocalePath, buildLocaleUrl } from "@/i18n/config";

function useCurrentLocale() {
    const { pathname } = useLocation();
    return parseLocalePath(pathname).locale;
}

function resolve(to, locale) {
    if (typeof to !== "string") return to;
    if (/^(https?:|mailto:|tel:|#)/.test(to)) return to;
    return buildLocaleUrl(to, locale);
}

export const Link = forwardRef(function LocaleLink({ to, ...rest }, ref) {
    const locale = useCurrentLocale();
    return <RouterLink ref={ref} to={resolve(to, locale)} {...rest} />;
});

export const NavLink = forwardRef(function LocaleNavLink({ to, ...rest }, ref) {
    const locale = useCurrentLocale();
    return <RouterNavLink ref={ref} to={resolve(to, locale)} {...rest} />;
});

export { useCurrentLocale };
